import { Injectable } from '@angular/core';

@Injectable({
  providedIn: 'root',
})
export class DateService {
  /**
   * Returns the current Date.
   */
  public getCurrent(): Date {
    return new Date();
  }
}
